module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/cover_front_simple_hyphen-16113b2f541cbdc0be78b480c652084c.svg";